import React from "react";
import { Row, Col, Card, Form } from "react-bootstrap";

const TransferenciasSection = ({
  formData,
  errors,
  handleChange,
  handleBlur,
  handleFocus,
  isReadOnly
}) => {
  const providerInfo = formData.providerInfo || {};

  return (
    <div className="form-section p-2 p-sm-3 mb-4 border rounded bg-white">
      <h5 className="bg-light p-2 mb-3 border-bottom">
        2.- INFORMACIÓN PARA TRANSFERENCIAS BANCARIAS
      </h5>

      <Row className="g-2 g-sm-3">

        {/* Email Transferencias */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">EMAIL PARA TRANSFERENCIAS:</Form.Label>
            <Form.Control
              type="email"
              maxLength="100"
              size="sm"
              isInvalid={!!errors.email_transferencia}
              value={providerInfo.email_transferencia || ""}
              onChange={handleChange("email_transferencia")}
              onBlur={handleBlur("email_transferencia")}
              onFocus={handleFocus("email_transferencia")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">
              {errors.email_transferencia}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Tipo de Cuenta */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">TIPO DE CUENTA:</Form.Label>
            <Form.Select
              size="sm"
              isInvalid={!!errors.tipo_cuenta}
              value={providerInfo.tipo_cuenta || ""}
              onChange={handleChange("tipo_cuenta")}
              onBlur={handleBlur("tipo_cuenta")}
              onFocus={handleFocus("tipo_cuenta")}
              disabled={isReadOnly}
            >
              <option value="">Seleccionar</option>
              <option value="Ahorros">Ahorros</option>
              <option value="Corriente">Corriente</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid" className="small">
              {errors.tipo_cuenta}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Número de Cuenta */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">NÚMERO DE CUENTA:</Form.Label>
            <Form.Control
              type="text"
              inputMode="numeric"
              maxLength="20"
              size="sm"
              isInvalid={!!errors.numero_cuenta}
              value={providerInfo.numero_cuenta || ""}
              onChange={handleChange("numero_cuenta")}
              onBlur={handleBlur("numero_cuenta")}
              onFocus={handleFocus("numero_cuenta")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">
              {errors.numero_cuenta}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Nombre del Banco */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">NOMBRE DEL BANCO:</Form.Label>
            <Form.Control
              type="text"
              maxLength="100"
              size="sm"
              isInvalid={!!errors.nombre_banco}
              value={providerInfo.nombre_banco || ""}
              onChange={handleChange("nombre_banco")}
              onBlur={handleBlur("nombre_banco")}
              onFocus={handleFocus("nombre_banco")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">
              {errors.nombre_banco}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

      </Row>
    </div>
  );
};

export default TransferenciasSection;